<template>
  <v-dialog v-model="isOpen" id="buckets-delete-dialog" width="500">
    <v-card class="pa-4">
      <v-card-title class="ma-0 mb-2 pa-0">
        <h2>Delete {{itemType}}</h2>
      </v-card-title>
      <v-card-text class="ma-0 mt-2 mb-1 pa-0">
        <p>Are you sure you want to delete this {{itemType}}?</p>
      </v-card-text>
      <v-card-actions class="ma-0 mt-3 pa-0">
        <v-btn @click="sendResponse(true)" id="bucket-delete-dialog-delete-btn" color="error">
          Yes, delete this {{itemType}}
        </v-btn>
        <v-btn @click="sendResponse(false)" id="bucket-delete-dialog-cancel-btn" color="secondary">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "delete-dialog",
  props: {
    isOpen: { type: Boolean },
    itemType: { type: String }
  },
  methods: {
    sendResponse(shouldDelete) {
      this.$emit("delete-item", shouldDelete)
    }
  }
}
</script>
